import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Order/OrderPositioningSetup.requests'
import {
    LocationSelectionDataType,
} from '../orderConfirmation.types'
import simpleApi from '../../../../../../services/simpleApi'

const useUpdateOriginServiceCenter = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessUpdate,
        onError,
    } = useHandleStatusRequest({
        id: 'UpdateOriginServiceCenter',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            version,
            orderNumber,
            data,
        }: {
            version: number,
            orderNumber: string,
            data: LocationSelectionDataType,
        }) => {
            return simpleApi({
                ...requests.updateOriginServiceCenter({
                    data: {
                        ...data,
                        version,
                    },
                    orderNumber,
                }),
                token,
            })
        },
        onSuccess: onSuccessUpdate,
        onError,
    })
}

export default useUpdateOriginServiceCenter
